module.exports = __webpack_public_path__ + "static/media/Outcome.002cbd8d.jpg";